import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { PasswordResetCodeForm } from "../../../../expert";
import PortalTextInput from "../../form-elements/portal-text-input/PortalTextInput";
import LoginButton from "../../buttons/login-button/LoginButton";
import ResendCodeForm from "./ResendCodeForm";
import { generalTextInputStyles, passwordInputProps } from "./PortalSignInForm";
const RegistrationCodeForm = ({
  classes,
  onPasswordResetComplete
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  return /*#__PURE__*/React.createElement(PasswordResetCodeForm, {
    onPasswordResetComplete: onPasswordResetComplete
  }, ({
    registrationCode,
    password,
    fieldErrors,
    isFormInvalid,
    onPasswordChange,
    onRegistrationCodeChange,
    onFormSubmit,
    loading,
    userErrorMessage,
    resendForgotPassword
  }) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.fieldContainer
    }, /*#__PURE__*/React.createElement(ResendCodeForm, {
      onResendClick: resendForgotPassword,
      errorMessage: userErrorMessage,
      onChange: onRegistrationCodeChange,
      loading: loading,
      value: registrationCode.value,
      fieldError: fieldErrors.registrationCode
    }), /*#__PURE__*/React.createElement(PortalTextInput, {
      name: "newPassword",
      label: "New Password",
      placeholder: "Your New Limitless Password",
      id: "newPasswordInputField",
      onChange: event => onPasswordChange(event.target.value),
      disabled: loading,
      value: password.value,
      error: fieldErrors.password ? true : false,
      helperText: fieldErrors.password,
      containerClass: classes.textInput,
      autoComplete: "new-password",
      color: "primary",
      largeHelperText: true,
      inputProps: {
        className: classes.textInputStyle
      },
      textInputClasses: {
        notchedOutline: classes.noBorderInput
      },
      type: showPassword ? "text" : "password",
      InputProps: passwordInputProps(() => setShowPassword(!showPassword), showPassword, classes),
      errorLabel: true
    }), /*#__PURE__*/React.createElement(LoginButton, {
      disabled: loading || isFormInvalid,
      loading: loading,
      type: "submit",
      component: "button",
      id: "sendRegistrationCodeButton",
      onClick: onFormSubmit
    }, "Confirm Reset"));
  });
};
const styles = theme => ({
  ...generalTextInputStyles(theme),
  fieldContainer: {
    width: "100%",
    maxWidth: 325,
    display: "flex",
    flexDirection: "column",
    marginBottom: 10
  },
  messageContainer: {
    height: 32
  },
  resendButton: {
    padding: 0,
    alignSelf: "center",
    paddingBottom: 2
  },
  textInput: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 8
  }
});
export default withStyles(styles)(RegistrationCodeForm);
RegistrationCodeForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onPasswordResetComplete: PropTypes.func.isRequired
};